/*
  Animate the offer cards (med and above only)
  moved from ajax-component.js
*/

import $ from 'jquery';
import responsive from 'lib/responsive';
import 'lazyload';

// arbitrary, taken from OG ajax-component.js.
// used to switch to 3000 for initialLoad, but who's counting?
var __timeoutDuration = 1500;

export default {
  animateOfferCards: function () {
    if (responsive() === 'sm') {
      this.lazyLoadCardImgs();
    } else {
      this.showLoadingOverlayCards();
      setTimeout(this.showCards.bind(this), __timeoutDuration);
    }
  },

  showLoadingOverlayCards: function () {
    var count = 0;
    $.each($('.isotope-item:not(.isotope-hidden) div[data-class="card-loading-overlay-selector"]'), function (index) {
      if (index && (index % 9 === 0)) {
        count = 1;
      } else {
        count += 1;
      }
      var duration = '.' + (count) + 's';
      $(this).addClass('is-running').attr('style', 'animation-delay: ' + duration); // .1s, .2s, .3s, etc
    });
  },

  showCards: function () {
    $.each($('.isotope-item:not(.isotope-hidden) div[data-class="card-loading-overlay-selector"]'), function () {
      $(this).removeClass('is-running').addClass('is-reverse');
    });
    this.lazyLoadCardImgs(); // via binding
  },

  lazyLoadCardImgs: function () {
    $('img.lazy-v', '.isotope-item:not(.isotope-hidden)  div[data-class="card-content"]').lazy({
      afterLoad: function ($el) {
        $el.css({ visibility: 'visible' });
      }
    });
  }
};
